import './Filters.scss';

import classNames from 'classnames';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';

import { HOME_CATEGORY_NAME_KEY } from '../../config/constants';
import { useSelectCategory } from '../../hooks/useSelectCategory';
import { DEFAULT_LANGUAGE } from '../../i18n/constants';
import { getUserLanguage } from '../../i18n/helpers';
import { useFlag } from '../../services/launchDarkly';
import { HOME_CATEGORY_ID } from '../../stores/categories/CategoriesStore';
import { useStores } from '../../stores/useStores';
import SearchButtonV2 from '../SearchButtonOldSearch/SearchButtonV2';

export const Filters = observer(() => {
  const { uiStore, categoriesStore, portalStore } = useStores();
  const { t, i18n } = useTranslation();
  const language = getUserLanguage(i18n.language);
  const { selectCategory } = useSelectCategory();

  const isSearchEnabled = useFlag('search_enabled', true);

  if (uiStore.openFullPageDialog || portalStore.isVisible) {
    return null;
  }

  return (
    <div className="filters">
      <div className="filters__wrapper">
        {isSearchEnabled && <SearchButtonV2 className="filters__search" />}
        <div className="filters__search__wrapper">
          <button
            className={classNames('filters__item', {
              filters__item_active: categoriesStore.currentId === HOME_CATEGORY_ID,
            })}
            data-testid="category-home"
            onClick={() => selectCategory(HOME_CATEGORY_ID)}
          >
            {t(HOME_CATEGORY_NAME_KEY)}
          </button>
          {categoriesStore.categoriesIds.map((id) => {
            const category = categoriesStore.categoriesRegistry[id];

            if (!category?.showInHeader) {
              return null;
            }

            return (
              <button
                key={id}
                className={classNames('animation-slide-left', 'filters__item', {
                  filters__item_active: categoriesStore.currentId === id,
                })}
                onClick={() => selectCategory(id)}
              >
                {category.name[language] || category.name[DEFAULT_LANGUAGE]}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
});
